//DEV url: 'https://www.sandbox.paypal.com/cgi-bin/webscr', subscribe_id: 'K2RBP3GRTBP96', unsubscribe_id: 'BA6NMKD8KEUB4'
//PROD url: 'https://www.paypal.com/cgi-bin/webscr', subscribe_id: 'XAL9JAVPYCHU2', unsubscribe_id: 'TRCG5G2ZNG3SC'
let config;
if (process.env.NODE_ENV === 'production') {
  config = { email: 'cklmprono@gmail.com', url: 'https://www.paypal.com/cgi-bin/webscr', subscribe_id: 'XAL9JAVPYCHU2', unsubscribe_id: 'TRCG5G2ZNG3SC', buy_id: 'V4SVUXGZEEYLJ', discount_id: '36LQK52ZHF9MG' }
} else {
  config = { email: 'dubocr@gmail.com', url: 'https://www.sandbox.paypal.com/cgi-bin/webscr', subscribe_id: 'D8TDJM8PZKN5A', unsubscribe_id: 'BA6NMKD8KEUB4', buy_id: 'QG9MRP2268KW6', discount_id: 'S8V9ZQWHY9ALC' }
}
export default config